import React from 'react'
import { Flex, Link, Text } from '@workwhile/ui'
import { useBookingDetailsContextValue } from '../context/BookingDetailsProvider'
import { DayforceJobRequestedWorker } from 'api/admin/dayforce/getDayforceJob'
import * as ROUTES from 'constants/routes'
import { useBookingShiftDetailContextValue } from './BookingShiftDetail/context/BookingShiftDetailProvider'

const WorkerRow = ({
  requestedWorker,
}: {
  requestedWorker: DayforceJobRequestedWorker
}) => {
  return (
    <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
      <td style={{ padding: '5px 0' }}>
        <Text>
          {requestedWorker.name}{' '}
          {requestedWorker.user_id ? (
            <Link
              to={ROUTES.USERS.replace(
                ':keyword',
                requestedWorker.user_id.toString()
              )}
              target="_blank"
            >
              ({requestedWorker.user_id})
            </Link>
          ) : null}
        </Text>
      </td>
      <td align="right">
        {requestedWorker.user_id ? (
          <Text fontSize="12px">Worker not on shift</Text>
        ) : (
          <Text fontSize="12px">Worker not found in WW</Text>
        )}
      </td>
    </tr>
  )
}

export const DayforceRequestedWorkers = () => {
  const {
    state: { dayforceBooking },
  } = useBookingDetailsContextValue()

  const {
    state: { workWhileShift },
  } = useBookingShiftDetailContextValue()

  const shiftWorkers = workWhileShift?.work?.map((work) => work.worker.id) ?? []

  const requestedWorkersMissing = dayforceBooking.requested_workers.filter(
    (requestedWorker) =>
      !requestedWorker.user_id ||
      !shiftWorkers.includes(requestedWorker.user_id)
  )

  if (!requestedWorkersMissing.length) {
    return null
  }

  return (
    <Flex flexDirection="column" gap={2}>
      <Text fontSize={3} fontWeight="bold">
        DF Requested Workers
      </Text>
      <table>
        <thead>
          <tr>
            <th>
              <Text fontWeight="bold">Name</Text>
            </th>
            <th>
              <Text fontWeight="bold" textAlign="center">
                Actions
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {requestedWorkersMissing.map((requestedWorker) => (
            <WorkerRow
              key={requestedWorker.id}
              requestedWorker={requestedWorker}
            />
          ))}
        </tbody>
      </table>
    </Flex>
  )
}
